import { usePubSub } from 'hooks/pubsub/usePubSub'

import { UnificacaoBaseTopic } from './model'

interface UnificacaoBaseListenerProps {
  handleMessage(message: UnificacaoBaseTopic)
}

export const UnificacaoBaseListener = (props: UnificacaoBaseListenerProps) => {
  const { handleMessage } = props

  usePubSub<UnificacaoBaseTopic>({
    topic: `/unificacao-base`,
    onMessage: handleMessage,
  })

  return null
}
